import React from 'react';
import PropTypes from 'prop-types';
import { ComponentLoader } from '../../global/ComponentLoader/ComponentLoader';

const importFunc = () => {
    return import(/* webpackChunkName: "PdpSharedDealerDetailsForm" */
    './PdpSharedDealerDetailsForm').then(moduleExport => moduleExport.PdpSharedDealerDetailsForm);
};

export function PdpSharedDealerDetailsFormLoader(props) {
    return (
        <ComponentLoader
            {...props}
            load={props.load}
            importFunc={importFunc}
            useLoadingComponent={false}
        />
    );
}

PdpSharedDealerDetailsFormLoader.propTypes = {
    load: PropTypes.bool.isRequired,
};
